import React, { useState } from 'react';
import Widget from './Widget';
import WidgetTitle from './WidgetTitle';
import { Card, Row } from 'react-bootstrap';

export default function Notes({ field, institutionData, className }) {

    let notes = institutionData.post_meta[field];
    let sae_default = '';
    if (field == 'sae-tab-notes') {
        sae_default = `<p>The data on this page are from the following sources, many of which are outlined in more detail on the Student Access and Earnings Classification methodology page.</p>
            <ul>
            <li>Pell grant recipient enrollment data are from the IPEDS Student Financial Aid Survey from 2022-23.</li>
            <li>Undergraduate student enrollment data by race/ethnicity are from the IPEDS 12-month Enrollment Survey from 2022-23.</li>
            <li>Underrepresented minority enrollment includes students reported as American Indian/Alaska Native, Black or African American, Hispanic or Latino, Native Hawaiian or Other Pacific Islander, or Two or More Races.</li>
            <li>Earnings data are from the College Scorecard and reflect the median earnings value eight years after entry for all undergraduate students who received federal financial aid, including full- and part-time students and including transfer or other non-first time students. Students who were enrolled in school, had died, or who did not report any income data were not included. These data are collected through a partnership of the U.S. Department of Education and the Internal Revenue Service.</li>
            <li>The comparison earnings value is a Carnegie Classifications-calculated figure that is described in more detail on the methodology page.</li>
            </ul>
            <p>Additional data is available on this page for context but was not used in the Carnegie Classifications. Outcome data, net price, and financial aid data was taken from the College Scorecard and reflect the most recent data available, which is generally from 2022.</p>`;
    }

    if (!notes.value && !sae_default) {
        return null;
    }

    const cardClass = (className || '');

    return (
        <Card className={cardClass} style={{ backgroundColor: '#FDF1D5' }}>
            <Card.Body>
                <Row>
                    <WidgetTitle>Notes</WidgetTitle>
                </Row>
                <Row>
                    <div className="notes-content" dangerouslySetInnerHTML={{ __html: `${sae_default} <p>${notes.value}</p>` }} ></div>
                </Row>
            </Card.Body>
        </Card >
    );
}